import { render, staticRenderFns } from "./AddSizeSidebar.vue?vue&type=template&id=e6ba3ee8&scoped=true&"
import script from "./AddSizeSidebar.vue?vue&type=script&lang=js&"
export * from "./AddSizeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddSizeSidebar.vue?vue&type=style&index=0&id=e6ba3ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ba3ee8",
  null
  
)

export default component.exports